<template>
    <section class="page-name-row _edit-section">
        <div class="section-inner">

            <div class="item-wrap">

                <div class="name-input-wrap">
                    <div class="item form_text _big2">
                        <input type="text" class="main" maxlength="250" id="shop-name1" placeholder=" " v-model="name" v-bind:class="{ '_error _required': $store.state.register.errors.name }">
                        <label for="shop-name1" class="m-label"><span>{{getName}}</span></label>
                    </div>

                    <div class="item form_text">
                        <input type="text" class="sub" maxlength="250" id="shop-name-furigana" placeholder=" " v-model="phonetic" v-bind:class="{ '_error _required': $store.state.register.errors.phonetic }">
                        <label for="shop-name-furigana" class="m-label"><span>{{getPhonetic}}</span></label>
                    </div>
                </div>

            </div>

        </div>
    </section><!--/.page-name-row-->
</template>

<script>

    import SvgIconThumbsUp from '@/components/EndUser/svg/SvgIconThumbsUp'
    import SvgIconHomeAdd from '@/components/EndUser/svg/SvgIconHomeAdd'
    import SvgIconShop from '@/components/EndUser/svg/SvgIconShop'
    import SvgIconMovie from '@/components/EndUser/svg/SvgIconMovie'

    export default {
        components: {
            SvgIconHomeAdd,
            SvgIconMovie,
            SvgIconShop,
            SvgIconThumbsUp,
        },
        data() {
            return {
                name: '',
                phonetic: '',
                user: '',
            };
        },
        watch: {
            name: function (value) {
                this.$store.state.register.form.name = value;
            },
            phonetic: function (value) {
                this.$store.state.register.form.phonetic = value;
            },
        },
        created() {
            if (this.$store.state.detail.set.brand.name) {
                this.name = this.$store.state.detail.set.brand.name;
            }
            if (this.$store.state.detail.set.brand.phonetic) {
                this.phonetic = this.$store.state.detail.set.brand.phonetic;
            }
            if (this.$store.state.detail.set.user) {
                this.user = this.$store.state.detail.set.user;
            }
        },
        computed: {
            getName() {
                var url = location.pathname;
                if (url.indexOf( '/brand' ) != -1) {
                    return 'ブランド名';
                } else if (url.indexOf( '/shop' ) != -1) {
                    return 'ショップ名';
                } else if (url.indexOf( '/showroom' ) != -1) {
                    return 'ショールーム名';
                }
            },
            getPhonetic() {
                var url = location.pathname;
                if (url.indexOf( '/brand' ) != -1) {
                    return 'ブランド名フリガナ';
                } else if (url.indexOf( '/shop' ) != -1) {
                    return 'ショップ名フリガナ';
                } else if (url.indexOf( '/showroom' ) != -1) {
                    return 'ショールーム名フリガナ';
                }
            },
            isShopPage() {
                var url = location.pathname;
                if (url.indexOf( '/shop' ) != -1) {
                    //ショップページの場合
                    return true;
                } else {
                    //ショップページではない場合
                    return false;
                }
            },
        }
    }
</script>

